// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/forced-induction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/forced-induction/forced-induction.js';

mount([g0]);
